<template>
  <div class="w_100per h_100per">
    <!-- 미리듣기 video -->
    <video ref="previewvideo" id="previewvideo" hidden playsinline @pause="onPause"></video>
    <!-- 설정하기 모달 -->
    <BroadCastInfoV2
      v-if="isSettintTime"
      :aibrandmusicid="selectSettingItme.aiBrandMusicId"
      :brandmusicid="selectSettingItme.brandMusicId"
      :playtype="selectSettingItme.playType"
      :selecttime="selectSettingItme.selectTime"
      :starttime="selectSettingItme.startTime"
      :endtime="selectSettingItme.endTime"
      :repeattime="selectSettingItme.repeatTime"
      @close-broadcastinfo="isSettintTime = false"
      @save-time="onSaveTime"
    />

    <!-- 삭제 모달 -->
    <ConfirmYesNoV2 v-if="isDeleteConfirmModal" @click-no="isDeleteConfirmModal = false" @click-yes="onClickYesDelete">
      <template #confirmmodal-nontitle>
        해당 파일을 삭제하시겠습니까?
      </template>
    </ConfirmYesNoV2>
    <!-- 현재 재생중인게 있을 경우 미리듣기 모달 -->
    <ConfirmYesNoV2 v-if="isPreviewAudioModal" @click-no="isPreviewAudioModal = false" @click-yes="onClickYesStopMusic">
      <template #confirmmodal-nontitle>
        현재 재생중인 음악을 잠시 멈추고 <br />
        선택하신 음악을 재생하시겠습니까?
      </template>
    </ConfirmYesNoV2>

    <!-- 삭제 완료 모달 -->
    <AlertModalV2
      v-if="isDeleteAlertModal"
      @confirm-btn="[(isDeleteAlertModal = false), (isDeleteConfirmModal = false)]"
    >
      <template #alertmodal-nontitle>
        삭제 되었습니다.
      </template>
    </AlertModalV2>

    <!-- 최대 10개 모달 -->
    <AlertModalV2 v-if="isMaxTenModal" @confirm-btn="isMaxTenModal = false">
      <template #alertmodal-nontitle>
        파일은 최대 10개까지 등록 가능해요.
      </template>
    </AlertModalV2>

    <!-- 시간설정 안되어 잇는 경우 모달 -->
    <ConfirmYesNoV2
      v-if="isSettingTimeModal"
      @click-no="isSettingTimeModal = false"
      @click-yes="onClickYesSettingTimeModal"
    >
      <template #confirmmodal-title>
        시간 설정
      </template>

      <template #confirmmodal-desc>
        방송/안내 활성화를 위해 시간설정이 <br />
        필요해요. 시간 설정을 하시겠어요?
      </template>
    </ConfirmYesNoV2>

    <!-- AI로고송 이용횟수 초과 -->
    <AlertModalV2 v-if="isOverUseAiMusic" @confirm-btn="isOverUseAiMusic = false">
      <template #alertmodal-nontitle v-if="spacePayAt === 'T'">
        {{ overUseText }}
      </template>
      <template #alertmodal-title v-if="spacePayAt === 'Y'">
        {{ overUseText }}
      </template>
      <template #alertmodal-desc v-if="spacePayAt === 'Y'"> {{ resetDate }} 이후 다시 이용가능합니다 </template>
    </AlertModalV2>

    <!-- AI로고송 이용횟수 초과 -->
    <AlertModalV2 v-if="isOverUseAiVoice">
      <template #alertmodal-title>
        오늘 이용횟수를 모두 사용하셨어요.
      </template>
      <template #alertmodal-desc>
        내일부터 다시 만들 수 있습니다. <br />
        다음에 다시 시도해주세요.
      </template>
    </AlertModalV2>

    <!-- 수정 불가능 팝업 -->
    <AlertModalV2 v-if="isEditDisabled" @confirm-btn="isEditDisabled = false">
      <template #alertmodal-nontitle>
        본사에서 일괄적으로 제공하는 <br />
        음원은 수정이 불가합니다
      </template>
    </AlertModalV2>

    <!--FileUpload -->
    <FileUploadModalV2
      v-if="isOpenFileUpload"
      @close-fileupload="isOpenFileUpload = false"
      @success-fileupload="onSuccessFileUpload"
    />

    <!-- VoiceRecording -->
    <VoiceRecordingV2
      v-if="isOpenVoiceRecorder"
      @close-voicerecorder="isOpenVoiceRecorder = false"
      @complete-voicerecorder="onCompleteVoicerecorder"
    />

    <!-- TextToSpeech -->
    <TextUploadModalV2
      v-if="isOpenAiVoice"
      :spacetype="spacePayAt"
      :resetdate="resetDate"
      @close-aivoice="onCloseAiVoice"
      @success-file="onSuccessFile"
    />
    <PageSlot>
      <template #pageslot-contents>
        <div class="max1200-container broadcast-container">
          <!-- broadcast-header -->
          <div class="broadcast-header">
            <h1 class="global_page_title broadcast-title">
              안내 방송
              <a class="info-iconwrap cursor" tabindex="0" @click="onOpenInfoMark" @keydown.enter="onOpenInfoMark">
                <img class="info-icon" src="/media/images/icon/Info-icon.png" alt="Info-icon.png" />
              </a>
              <img
                v-if="isOpenInfoMark"
                v-click-outside="onOpenInfoMark"
                class="broadcast-speech-ballonwrap"
                src="/media/img/broadcast/broadcast-speech-ballon.png"
                alt="broadcast-speech-ballon.png"
              />
            </h1>
          </div>

          <!-- broadcast-selecttab-->
          <div class="broadcast-selecttab">
            <CommonSelectTab v-if="isBrand" :selecttab="selecTab" @click-tab="onClickTab">
              <template #firstitem>
                마이
              </template>
              <template #seconditem>
                브랜드 음악
              </template>
            </CommonSelectTab>

            <!-- 마이사운드 버튼 -->
            <div class="addmysoundbtn" v-if="selecTab === 1">
              <!-- 말풍선 -->
              <div class="speech-bubble" v-if="getIsOpenAiLogoSongTooltip && generateMusicCount.totalCount === 6">
                <span class="mysnd-event">Event</span>
                <span class="speech-bubble-text">첫 달은 AI 로고송 3+3!</span>
                <a class="speech-bubble-closewrap" tabindex="0" @click="onClickTooltip">
                  <img
                    class="speech-bubble-close"
                    src="/media/images/icon/close-bold-icon.png"
                    alt="close-bold-icon.png"
                  />
                </a>
                <div class="triangle"></div>
              </div>
              <BasicButton :boxsize="'sm'" @click-btn="onClickAddSound">
                <template #before-icon>
                  <img class="addmysnd-icon" src="/media/images/icon/add-space-icon.png" alt="add-space-icon.png" />
                </template>
                <template #btnname>
                  안내 방송
                </template>
              </BasicButton>

              <!-- 파일업로드 / 음성녹음 / TTS -->
              <div class="add-mysndlist" v-if="isOpenAddMysnd" v-click-outside="onClickOutsideMySndList">
                <a class="add-mysnd-item" tabindex="0" @click="goAiMusic">
                  <img class="mysnd-addicon" src="/media/images/icon/ai-logo-icon.png" alt="AI 로고송" />
                  AI 로고송
                  <div class="mysnd-count">
                    <strong>{{ generateMusicCount.availableCount }}</strong
                    >회 남음
                  </div>
                </a>
                <a class="add-mysnd-item" @click="onClickAiVoice" tabindex="0">
                  <img class="mysnd-addicon" src="/media/images/icon/aivoice-icon.png" alt="upload-icon.png" />
                  AI 보이스
                  <div class="mysnd-count">
                    <strong> {{ tts.availableCount }}</strong
                    >회 남음
                  </div>
                </a>
                <a class="add-mysnd-item" tabindex="0" @click="[(isOpenFileUpload = true), (isOpenAddMysnd = false)]">
                  <img class="mysnd-addicon" src="/media/images/icon/upload-icon.png" alt="upload-icon.png" />
                  파일업로드
                </a>
                <a
                  class="add-mysnd-item"
                  tabindex="0"
                  @click="[(isOpenVoiceRecorder = true), (isOpenAddMysnd = false)]"
                >
                  <img class="mysnd-addicon" src="/media/images/icon/recorder-icon.png" alt="upload-icon.png" />
                  음성 녹음
                </a>
              </div>
            </div>
          </div>

          <!-- broadcast-contents -->
          <div class="broadcast-contents">
            <!-- 사운드 없는 경우(브랜드인 경우)-->
            <div class="broadcast-nolist" v-if="brandList.length === 0 && selecTab === 2">
              <img class="nosound-icon" src="/media/images/icon/no-sound-icon.png" alt="no-sound-icon.png" />
              <p class="nosound-text">등록된 사운드가 없습니다.</p>
            </div>
            <!-- 사운드 없는 경우(마이사운드인 경우)-->
            <div class="broadcast-nolist mysnd" v-else-if="brandList.length === 0 && selecTab === 1">
              <p class="mysnd-nolist-txt">
                매장 운영에 필요한 다양한 맞춤 방송을 만들고 <br />
                주기적으로 재생해 보세요!
              </p>
              <ul class="mysnd-nolist-imglist">
                <li>
                  <img class="mysnd-nolist-img" src="/media/img/broadcast/mysnd-infoimg1.png" alt="신메뉴 홍보" />
                </li>
                <li>
                  <img class="mysnd-nolist-img" src="/media/img/broadcast/mysnd-infoimg2.png" alt="이벤트 안내" />
                </li>
                <li>
                  <img class="mysnd-nolist-img" src="/media/img/broadcast/mysnd-infoimg3.png" alt="신메뉴 홍보" />
                </li>
                <li>
                  <img class="mysnd-nolist-img" src="/media/img/broadcast/mysnd-infoimg4.png" alt="신메뉴 홍보" />
                </li>
              </ul>
            </div>
            <!-- 사운드 있는 경우 -->
            <ul class="mysnd-list" v-else>
              <li class="mysnd-listheader">
                <!-- 파일명 -->
                <span class="file-name-wrap">파일명</span>
                <!-- 유형(마이사운드의 경우에만)-->
                <span class="category-name-wrap" v-if="selecTab === 1">유형</span>
                <!-- 시간설정-->
                <span class="settingtime-wrap"> 시간설정</span>
                <!-- 재생여부 -->
                <span class="isplay-wrap">재생여부</span>
                <!-- 미리듣기 -->
                <span class="play-wrap">미리듣기</span>

                <!-- 삭제(마이사운드의 경우에만) -->
                <span class="delete-wrap" v-if="selecTab === 1">
                  삭제
                </span>
              </li>
              <li class="mysnd-item" v-for="(item, index) in brandList" :key="item.brandMusicId">
                <!-- 파일명-->
                <div class="file-name-wrap item">
                  <span class="file-name">{{ item.brandMusicNm }} </span>
                </div>

                <!-- 유형 -->
                <div class="category-name-wrap item" v-if="selecTab === 1">
                  <span class="category-name">{{ item.typeName }}</span>
                </div>

                <div
                  class="settingtime-wrap cursor item"
                  :class="!item.playType ? 'nohover' : ''"
                  @mouseenter="onMouseenter(item)"
                  @mouseleave="onMouseLeave(item)"
                  @click="onClickSetting(item)"
                >
                  <!-- 시간표시 -->
                  <div class="settingtime-box">
                    <!-- 지정 -->
                    <span class="seletimebadge" v-if="item.playType === 'S'">지정</span>
                    <span class="broadcast-time time" v-if="item.playType === 'S'">{{ item.selectTime }}</span>

                    <!-- 반복 -->
                    <span class="repeattimebadge" v-if="item.playType === 'R'">반복</span>

                    <span class="broadcast-time time" v-if="item.playType === 'R'"
                      >{{ item.startTime }} ~ {{ item.endTime }}</span
                    >
                    <span class="broadcast-time" v-if="item.playType === 'R'">{{ item.repeatTime }}시간 마다</span>

                    <!-- 설정하기 -->
                    <button class="broadcast-setting-btn" v-if="!item.playType" @click="onClickTimeSetting(item)">
                      설정하기
                    </button>
                  </div>
                  <!-- 수정아이콘  -->
                  <div class="settingtime-btn" v-if="item.isActiveEdit">
                    <img class="edit-icon" src="/media/images/icon/edit-icon.png" alt="edit-icon.png" />
                  </div>
                </div>

                <div class="isplay-wrap">
                  <ToggleBox
                    :tooglevalue="item.playAt === 'Y' ? true : false"
                    @click-toogle="updateBrandSpaceMusicPlayAt(item)"
                    @transition-end="onTransitionEnd"
                  />
                </div>

                <div class="play-wrap">
                  <!-- mysnd-pause-icon.png -->
                  <img
                    @click="onClickPreviewPlay(item, index)"
                    class="mysnd-play-icon"
                    :src="
                      previewActiveIndex === index
                        ? '/media/images/icon/mysnd-pause-icon.png'
                        : '/media/images/icon/mysnd-play-icon.png'
                    "
                    alt="mysnd-play-icon.png"
                  />
                </div>

                <div class="delete-wrap cursor" v-if="selecTab === 1">
                  <img
                    class="delete-icon"
                    @click="onClickDelete(item)"
                    src="/media/images/icon/delete-icon-sm.png"
                    alt="delete-icon-sm.png"
                  />
                </div>
              </li>
            </ul>
          </div>

          <!-- broadcast-notice -->
          <div class="broadcast-notice" v-if="selecTab === 1">
            <span class="broadcast-noticetitle">유의사항</span>
            <div class="broadcast-noticelistwrap">
              <NoticeList
                :noticelist="[
                  '파일은 최대 10개까지 등록 가능합니다.',
                  '‘AI 로고송’ 이용 가능 횟수는 월 3회입니다. 이용 가능 횟수는 구독일자 기준으로 매월 초기화됩니다.',
                  '‘AI 보이스’ 이용 가능 횟수는 월 10회입니다. 이용 가능 횟수는 구독일자 기준으로 매월 초기화됩니다.'
                ]"
              />
            </div>
          </div>
        </div>
      </template>
    </PageSlot>
  </div>
</template>
<script>
import PageSlot from '@/slot/PageSlot.vue';
import NoticeList from '@/components/common/NoticeList.vue';
import CommonSelectTab from '@/components/common/CommonSelectTab.vue';
import BasicButton from '@/components/BasicButton/BasicButton.vue';
import ToggleBox from '@/components/ToggleBox/ToggleBox.vue';
import ConfirmYesNoV2 from '@/components/common/ConfirmYesNoV2.vue';
import AlertModalV2 from '@/components/modal/AlertModalV2.vue';
import BroadCastInfoV2 from '@/components/BroadCast/BroadCastInfoV2.vue';
import FileUploadModalV2 from '@/components/BroadCast/FileUploadModalV2.vue';
import VoiceRecordingV2 from '@/components/BroadCast/VoiceRecordingV2.vue';
import TextUploadModalV2 from '@/components/BroadCast/TextUploadModalV2.vue';
import {
  getBrandSpaceMusicList,
  updateBrandSpaceMusicPlayAtApi,
  updateSpaceMusicRepeatTimeApi,
  updateSpaceMusicSelectTimeApi,
  updateSpaceMusicStartTimeApi
} from '@/service/api/playerApi';
import { deleteMySoundApi, getListOfMySoundApi, getMysndCountAndResetDateApi } from '@/service/api/mySoundApi';
import { mySpaceInfo } from '@/service/api/profileApi';
import Hls from 'hls.js';
import { CustomLoader } from '@/assets/js/CustomLoader';
import vClickOutside from 'v-click-outside';
import { isDomainFormat } from '@/utils/Utils';
export default {
  beforeRouteEnter(to, from, next) {
    const { name } = from;

    if (name === 'CompleteAiMusic' || name === 'AiMusicChat') {
      next(vm => {
        vm.previousRoute = name;
      });
      return;
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.$gatag.event('web_broadcast_page_back'); // 안내방송 페이지 뒤로가기

    next();
  },
  components: {
    PageSlot,
    CommonSelectTab,
    NoticeList,
    BasicButton,
    ToggleBox,
    ConfirmYesNoV2,
    AlertModalV2,
    BroadCastInfoV2,
    FileUploadModalV2,
    VoiceRecordingV2,
    TextUploadModalV2
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  async mounted() {
    this.$gatag.event('web_broadcast_detail_page_confirm'); // 방송음원 상세페이지 확인
    await this.getMySpaceInfo();
    this.getMysndCount();
    this.getListOfMySound();
  },
  data() {
    return {
      selecTab: 1,
      isOpenSpeechBubble: true,
      isOpenAddMysnd: false,
      isActiveEdit: false,
      isDeleteConfirmModal: false,
      isPreviewAudioModal: false,
      isDeleteAlertModal: false,
      isMaxTenModal: false,
      isSettingTimeModal: false,
      isSettintTime: false,
      isOpenFileUpload: false,
      isOpenVoiceRecorder: false,
      isOpenAiVoice: false,
      isOverUseAiMusic: false,
      isOverUseAiVoice: false,
      isEditDisabled: false,
      spaceId: this.$cookies.get('spaceId'),
      userId: this.$cookies.get('userId'),
      isBrand: false,
      soundList: [],
      brandList: [],
      selectPlayBranditem: null,
      config: {
        enableWorker: true,
        lowLatencyMode: true,
        backBufferLength: 90,
        loader: CustomLoader
      },
      previewActiveIndex: -1,
      selectSettingItme: null,
      deleteItem: null,
      isOpenInfoMark: false,
      aiVoiceCount: 0,
      generateMusic: {
        availableCount: 0,
        totalCount: 0
      },
      tts: {
        availableCount: 0,
        totalCount: 0
      },
      resetDate: null,
      spacePayAt: null,
      previousRoute: null
    };
  },
  methods: {
    onClickYesSettingTimeModal() {
      this.$gatag.event('web_broadcast_page_brand_music_need_time_setting'); // 시간 설정 안내 팝업
      this.isSettingTimeModal = false;
      this.isSettintTime = true;
    },
    onCloseAiVoice() {
      this.isOpenAiVoice = false;
      this.getMysndCount();
    },
    onClickOutsideMySndList() {
      this.isOpenAddMysnd = false;
    },
    goAiMusic() {
      if (this.generateMusic.totalCount - this.generateMusic.availableCount === this.generateMusic.totalCount) {
        this.$gatag.event('web_ai_song_limit'); // 로고송 생성 리밋 팝업
        this.isOverUseAiMusic = true;
        return;
      }
      sessionStorage.removeItem('isWatchVideo');
      this.$router.push({ name: 'AiMusicChat' });
    },
    onClickAiVoice() {
      if (this.tts.totalCount - this.tts.availableCount === this.tts.totalCount) {
        this.$gatag.event('web_ai_voice_limit'); // ai 보이스 생성 리밋
        this.isOverUseAiMusic = true;
        this.isOpenAddMysnd = false;
        return;
      }
      this.isOpenAiVoice = true;
      this.isOpenAddMysnd = false;
    },
    /**
     * @description AI보이스 / AI음악 Count
     */
    async getMysndCount() {
      try {
        const { data } = await getMysndCountAndResetDateApi(this.userId, this.spaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { generateMusic, tts, resetDate } = result;
          this.generateMusic = generateMusic;
          this.tts = tts;
          if (resetDate) {
            this.resetDate = resetDate.replaceAll('-', '.');
          }
        } else {
          //
        }
      } catch (error) {
        console.log(error);
      }
    },
    onOpenInfoMark() {
      this.isOpenInfoMark = !this.isOpenInfoMark;
    },
    onPause() {
      this.previewActiveIndex = -1;
    },
    goBack() {
      this.$router.back();
    },
    onClickAddSound() {
      if (this.selecTab === 1 && this.brandList.length >= 10) {
        this.isMaxTenModal = true;
        return;
      }
      this.isOpenAddMysnd = !this.isOpenAddMysnd;
    },
    onCompleteVoicerecorder() {
      this.isOpenVoiceRecorder = false;
      this.isOpenAddMysnd = false;
      if (this.selecTab === 1) {
        this.getListOfMySound();
      } else if (this.selecTab === 2) {
        this.getBrandMusic();
      }
    },
    onSuccessFile() {
      this.isOpenAiVoice = false;
      this.isOpenAddMysnd = false;
      if (this.selecTab === 1) {
        this.getListOfMySound();
        this.getMysndCount();
      } else if (this.selecTab === 2) {
        this.getBrandMusic();
      }
    },
    onSuccessFileUpload() {
      this.isOpenFileUpload = false;
      this.isOpenAddMysnd = false;
      if (this.selecTab === 1) {
        this.getListOfMySound();
      } else if (this.selecTab === 2) {
        this.getBrandMusic();
      }
    },
    onClickDelete(item) {
      this.$gatag.event('web_broadcast_mysound_delete_popup'); // 마이사운드 삭제 팝업
      this.deleteItem = item;
      this.isDeleteConfirmModal = false;
      this.isDeleteConfirmModal = true;
    },
    async onClickYesDelete() {
      try {
        if (this.deleteItem) {
          this.$gatag.event('web_broadcast_mysound_delete'); // 마이사운드 삭제
          const { data } = await deleteMySoundApi(
            this.userId,
            this.deleteItem.brandMusicId,
            this.deleteItem.mySoundDetail
          );
          const { resultCd } = data;
          if (resultCd === '0000') {
            this.isDeleteConfirmModal = false;
            this.isDeleteAlertModal = true;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (this.selecTab === 1) {
          this.getListOfMySound();
        } else if (this.selecTab === 2) {
          this.getBrandMusic();
        }
      }
    },
    async onSaveTime(item) {
      if (item.playType) {
        const brandMusicId = isDomainFormat(item.brandMusicId) ? item.aiBrandMusicId : item.brandMusicId;
        if (item.playType === 'S') {
          try {
            await updateSpaceMusicSelectTimeApi(brandMusicId, this.spaceId, item.selectTime);
          } catch (error) {
            console.log(error);
          } finally {
            this.isSettintTime = false;
            if (this.selecTab === 1) {
              await this.getListOfMySound();
            } else if (this.selecTab === 2) {
              await this.getBrandMusic();
            }
            /* CronTab 세팅  */
            this.$store.dispatch('cronjob/settingCronJob');
          }
        } else {
          try {
            await updateSpaceMusicStartTimeApi(this.spaceId, brandMusicId, item.startTime, item.endTime);
            await updateSpaceMusicRepeatTimeApi(this.spaceId, brandMusicId, item.repeatTime);
          } catch (error) {
            console.log(error);
          } finally {
            this.isSettintTime = false;
            if (this.selecTab === 1) {
              await this.getListOfMySound();
            } else if (this.selecTab === 2) {
              await this.getBrandMusic();
            }
            /* CronTab 세팅  */
            this.$store.dispatch('cronjob/settingCronJob');
          }
        }
      }
    },
    onClickSetting(item) {
      // 브랜드 음악 && spaceId가 null 인 경우는 수정 불가능
      if (this.selecTab === 2 && !item.spaceId) {
        this.$gatag.event('web_broadcast_page_brand_music_no_change'); // 본사 일괄 재생 음원은 변경 불가 팝업
        this.isEditDisabled = true;
        return;
      }
      if (!item.playType) return;
      if (item) {
        this.selectSettingItme = item;
        this.isSettintTime = true;
      }
    },
    onClickTimeSetting(item) {
      if (item) {
        this.selectSettingItme = item;
        this.isSettintTime = true;
      }
    },
    async getMySpaceInfo() {
      try {
        const { data } = await mySpaceInfo(this.spaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { brandId, spacePayAt: spAt } = result;
          this.spacePayAt = spAt;
          if (brandId) {
            this.isBrand = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getBrandMusic() {
      try {
        const { data } = await getBrandSpaceMusicList(this.spaceId);

        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.brandList = result.map(item => {
            return {
              ...item,
              isActiveEdit: false
            };
          });
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        this.brandList = [];
        console.log(error);
      }
    },
    async updateBrandSpaceMusicPlayAt(item) {
      // 브랜드 음악 && spaceId가 null 인 경우는 수정 불가능
      if (this.selecTab === 2 && !item.spaceId) {
        this.isEditDisabled = true;
        return;
      }

      if (!item.playType) {
        this.isSettingTimeModal = true;
        this.selectSettingItme = item;
        return;
      }
      try {
        const brandMusicId = isDomainFormat(item.brandMusicId) ? item.aiBrandMusicId : item.brandMusicId;
        await updateBrandSpaceMusicPlayAtApi(this.spaceId, brandMusicId);
        item.playAt = item.playAt === 'Y' ? 'N' : 'Y';
      } catch (error) {
        console.log(error);
      } finally {
        /* CronTab 세팅  */
        this.$store.dispatch('cronjob/settingCronJob');
      }
    },
    async getListOfMySound() {
      try {
        const { data } = await getListOfMySoundApi(this.userId, this.spaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.brandList = result.listResult.map(item => {
            return {
              brandMusicNm: item.brandMusicNm,
              brandMusicId: item.brandMusicId,
              brandMusicPath: item.brandMusicPath,
              brandSpaceMusicId: item.mySoundDetail.brandMusicId,
              playAt: item.mySoundDetail.playAt,
              playType: item.mySoundDetail.playType,
              endTime: item.mySoundDetail.endTime,
              startTime: item.mySoundDetail.startTime,
              spaceId: item.mySoundDetail.spaceId,
              repeatTime: item.mySoundDetail.repeatTime,
              selectTime: item.mySoundDetail.selectTime,
              mySoundDetail: item.mySoundDetail,
              typeName: item.typeName,
              isActiveEdit: false,
              aiBrandMusicId: item.mySoundDetail.brandMusicId
            };
          });
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        this.brandList = [];
        console.log(error);
      }
    },
    onClickTab(val) {
      this.selecTab = val;
      if (val === 1) {
        this.getListOfMySound();
      } else {
        this.getBrandMusic();
      }
    },
    onMouseenter(item) {
      if (!item.playType) return;
      item.isActiveEdit = true;
    },
    onMouseLeave(item) {
      item.isActiveEdit = false;
    },
    onClickPreviewPlay(item, index) {
      this.$gatag.event('web_broadcast_detail_page_pre_speech'); // 미리듣기
      this.selectPlayBranditem = item;
      if (this.$store.state.isPlay) {
        this.$gatag.event('web_ai_generate_item_preview_play_confirm'); // 로고송 재생중 미리듣기 팝업
        this.isPreviewAudioModal = true;
        return;
      }
      if (this.previewActiveIndex === index) {
        this.previewStop();
        return;
      }
      this.previewActiveIndex = index;
      this.previewPlay();
    },
    onClickYesStopMusic() {
      this.isPreviewAudioModal = false;

      const findIdx = this.brandList.findIndex(item => this.selectPlayBranditem.brandMusicId === item.brandMusicId);

      if (this.previewActiveIndex === findIdx) {
        this.previewStop();
        return;
      }
      this.previewActiveIndex = findIdx;
      this.$store.dispatch('controlMusic');
      this.previewPlay();
    },
    async onTransitionEnd() {
      if (this.selecTab === 1) {
        await this.getListOfMySound();
      } else if (this.selecTab === 2) {
        await this.getBrandMusic();
      }
    },
    previewStop() {
      this.previewActiveIndex = -1;
      this.$refs.previewvideo.pause();
    },
    previewPlay() {
      if (this.$refs.previewvideo) {
        this.$refs.previewvideo.addEventListener('ended', this.previewPlayEndEvent, { once: true });
        const url = this.selectPlayBranditem.brandMusicId;
        const host = window.location.host;

        if (!isDomainFormat(url)) {
          const isLocalhostOr172 =
            host.includes('localhost') || /^172\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host.split(':')[0]);
          const tg = isLocalhostOr172
            ? 'https://dev.www.aplayz.co.kr/stream/getMusic?' + url
            : '/stream/getMusic?' + url;
          if (Hls.isSupported()) {
            let hls = null;
            hls = new Hls(this.config);
            hls.loadSource(tg);
            hls.attachMedia(this.$refs.previewvideo);
            this.$refs.previewvideo.play();
          }
        } else {
          this.$refs.previewvideo.src = url;

          this.$refs.previewvideo.play();
        }
      }
    },
    previewPlayEndEvent() {
      this.previewActiveIndex = -1;
    },
    onClickTooltip() {
      this.$store.commit('setIsOpenAiLogoSongTooltip', 'N');
    }
  },
  computed: {
    getSoundList() {
      if (this.selecTab === 1) {
        return [];
      } else if (this.selecTab === 2) {
        return this.soundList.map(item => {
          return {
            ...item
          };
        });
      }
      return [];
    },
    generateMusicCount() {
      return {
        availableCount: this.generateMusic.availableCount,
        totalCount: this.generateMusic.totalCount
      };
    },
    getIsOpenAiLogoSongTooltip() {
      return this.$store.getters.getIsOpenAiLogoSongTooltip === 'Y';
    },
    overUseText() {
      if (this.spacePayAt === 'T') {
        return `이번달 이용횟수를 모두 사용하셨어요.`;
      } else if (this.spacePayAt === 'Y') {
        return `이번달 이용 가능횟수를 모두 사용하셨습니다.`;
      }
      return '';
    }
  }
};
</script>
<style scoped src="@/assets/css/broadcast/broadcast.css"></style>
